import {ValueDefinition} from '@/model/types';

export const enum Operations {
  DEPOSIT = 'DV-48#0',
  TRANSFER_SAME_PLAN = 'DV-48#1',
  TRANSFER_BETWEEN_PLANS = 'DV-48#2',
  REDEMPTION_FEE = 'DV-48#3',
  ADDRESS_CHANGE = 'DV-48#4',
  MODIFY_OR_TERMINATE_PERIODIC_DEPOSIT = 'DV-48#5',
  REQUEST_FOR_CASH_WITHDRAWAL = 'DV-48#6',
  GUARANTEE_OPTION_CHANGE = 'DV-48#7',
  MODIFY_OR_DISCONTINUE_PAYROLL_DEDUCTION = 'DV-48#8',
}

export const DV_48 = {
  id: 'DV-48',
  description: {
    fr: 'Opération',
    en: 'Operation',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Dépôt',
        en: 'Deposit',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Virement même régime',
        en: 'Transfer within the same plan',
      },
    },
    {
      id: '2',
      value: {
        fr: 'Virement entre deux régimes',
        en: 'Transfer between two plans',
      },
    },
    {
      id: '3',
      value: {
        fr: 'Remboursement de frais',
        en: 'Redemption fee',
      },
    },
    {
      id: '4',
      value: {
        fr: 'Modification d’adresse',
        en: 'Address change',
      },
    },
    {
      id: '5',
      value: {
        fr: 'Modifier ou cesser dépôt périodique',
        en: 'Modify or terminate periodic deposit',
      },
    },
    {
      id: '6',
      value: {
        fr: 'Demander un retrait comptant',
        en: 'Request for cash withdrawal',
      },
    },
    {
      id: '7',
      value: {
        fr: "Modification de l'option de garantie",
        en: 'Guarantee Option Change',
      },
    },
    {
      id: '8',
      value: {
        en: 'Modify or discontinue payroll deduction',
        fr: 'Modifier ou cesser retenue salariale',
      },
    },
  ],
} as const satisfies ValueDefinition;
